import React, { useEffect, useState } from "react";
import { ensureTokenValidity } from "../auth/auth";
import { jwtDecode } from "jwt-decode";

function Login() {
    const [IsLoading, setIsLoading] = useState(true);
    const [userInfo, setUserInfo] = useState(null);

    function callback(user) {
        console.log('Login successful', user);

        const token = user.token;
        if (token) {
            localStorage.setItem('token', token);

            try {
                const decodedToken = jwtDecode(token);
                console.log('Decoded Token:', decodedToken);

                   // Extraire toutes les informations du user du token décodé
                const userData = {
                    name: decodedToken.name || 'user',
                    preferredUsername: decodedToken.preferred_username,
                    email: decodedToken.email,
                    givenName: decodedToken.given_name,
                    familyName: decodedToken.family_name,
                    airspaceName: decodedToken.airspace_name,
                    allowedOrigins: decodedToken['allowed-origins'] || [],
                };

                localStorage.setItem('user-INFO', JSON.stringify(userData));
                setUserInfo(userData); 
                console.log(`Welcome, ${userData.name}!`);

            } catch (error) {
                console.error('Failed to decode token:', error);
            }
        } else {
            console.warn('No token found in localStorage.');
        }

        setIsLoading(false); 
        window.location.href = '/';
    }

    useEffect(() => {
        ensureTokenValidity(callback);
    }, []);

    return (
        <div>
            {IsLoading ? (
                <p>Loading...</p>
            ) : (
                userInfo && (
                    <div>
                        
                    </div>
                )
            )}
        </div>
    );
}

export default Login;
